import {
  InfoPOG_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  InfoPOG_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD,
  InfoPOG_MASSIVE_UPLOAD_REQUEST_VERIFY,
  InfoPOG_MASSIVE_UPLOAD_SET_VERIFY,
  InfoPOG_MASSIVE_UPLOAD_CLEAR_VERIFY,
  InfoPOG_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  InfoPOG_MASSIVE_UPLOAD_SET_UPLOAD,
  InfoPOG_MASSIVE_UPLOAD_CLEAR_UPLOAD,
} from '../actions';

function InfoPOGMassiveUploadReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    case InfoPOG_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: action.payload,
      };

    case InfoPOG_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: null,
      };

    case InfoPOG_MASSIVE_UPLOAD_REQUEST_VERIFY:
      return {
        ...state,
        isLoading: true,
        verify: null,
      };

    case InfoPOG_MASSIVE_UPLOAD_SET_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: action.payload,
      };

    case InfoPOG_MASSIVE_UPLOAD_CLEAR_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: null,
      };

    case InfoPOG_MASSIVE_UPLOAD_REQUEST_UPLOAD:
      return {
        ...state,
        isLoading: true,
        upload: null,
      };

    case InfoPOG_MASSIVE_UPLOAD_SET_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: action.payload,
      };

    case InfoPOG_MASSIVE_UPLOAD_CLEAR_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: null,
      };

    default:
      return state;
  }
}

export default InfoPOGMassiveUploadReducer;
